/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import Vue from 'vue';

/**
 * Eventbus service.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export const eventBus: Vue = new Vue();
